import FoxBouncingLoader from "@/components/FoxBouncingLoader";

const Loader2 = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-16 bg-gradient-to-b from-background to-muted/30 py-12">
      <h1 className="text-2xl font-bold text-foreground">Fox Full Silhouette Loader</h1>

      <div className="flex flex-col items-center gap-4">
        <p className="text-sm text-muted-foreground">400px</p>
        <FoxBouncingLoader size={400} />
      </div>

      <div className="flex flex-col items-center gap-4">
        <p className="text-sm text-muted-foreground">250px</p>
        <FoxBouncingLoader size={250} />
      </div>

      <div className="flex flex-col items-center gap-4">
        <p className="text-sm text-muted-foreground">150px (small)</p>
        <FoxBouncingLoader size={150} />
      </div>
    </div>
  );
};

export default Loader2;
